import React from "react";
import classNames from "classnames";
import { ReactNode } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.5s ease-out;

    &.expanded {
        grid-template-rows: 1fr;
    }
`;

const Content = styled.div`
    overflow: hidden;
`;

const Excerpt = styled.div`
    overflow: hidden;
`;

export interface CollapsibleProps {
    className?: string;
    excerptClassName?: string;
    contentClassName?: string;
    collapsed?: boolean;
    excerpt?: ReactNode;
    children: ReactNode;
}

function Collapsible({
    collapsed = true,
    className,
    children,
    contentClassName,
    excerpt,
    excerptClassName,
}: CollapsibleProps) {
    return (
        <>
            {excerpt && <Excerpt className={classNames(excerptClassName)}>{excerpt}</Excerpt>}
            <Wrapper
                className={classNames(collapsed ? "" : "expanded", className)}
                aria-expanded={!collapsed}
            >
                <Content className={classNames(contentClassName)}>{children}</Content>
            </Wrapper>
        </>
    );
}

export default Collapsible;
